/**
 * This file is AUTO GENERATED by [msw-auto-mock](https://github.com/zoubingwu/msw-auto-mock)
 * Feel free to commit/edit it as you need.
 */
/* eslint-disable */
/* tslint:disable */
import { http, HttpResponse } from 'msw';
import { faker } from '@faker-js/faker';
import { setupWorker } from 'msw/browser';

faker.seed(1);

const baseURL = '';
const MAX_ARRAY_LENGTH = 20;

let i = 0;
const next = () => {
  if (i === Number.MAX_SAFE_INTEGER - 1) {
    i = 0;
  }
  return i++;
};

export const handlers = [
  http.get(`${baseURL}/api/business-customers/me`, () => {
    const resultArray = [
      [getGetAppBusinessCustomerGetCurrent200Response(), { status: 200 }],
      [getGetAppBusinessCustomerGetCurrent404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/authorized-persons`, () => {
    const resultArray = [
      [getGetAppAuthorizedPersonList200Response(), { status: 200 }],
      [getGetAppAuthorizedPersonList400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/authorized-persons`, () => {
    const resultArray = [
      [getPostAppAuthorizedPersonCreate200Response(), { status: 200 }],
      [getPostAppAuthorizedPersonCreate400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.delete(`${baseURL}/api/authorized-persons/:id`, () => {
    const resultArray = [
      [null, { status: 204 }],
      [getDeleteAppAuthorizedPersonDelete404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/business-customers`, () => {
    const resultArray = [
      [getPostAppBusinessCustomerCreate201Response(), { status: 201 }],
      [getPostAppBusinessCustomerCreate400Response(), { status: 400 }],
      [getPostAppBusinessCustomerCreate409Response(), { status: 409 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/cost-groups`, () => {
    const resultArray = [
      [getPostAppCostGroupCreate201Response(), { status: 201 }],
      [getPostAppCostGroupCreate400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/cost-groups/mine`, () => {
    const resultArray = [
      [getGetAppCostGroupListMine200Response(), { status: 200 }],
      [getGetAppCostGroupListMine400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/cost-groups/:id`, () => {
    const resultArray = [
      [getGetAppCostGroupGet200Response(), { status: 200 }],
      [getGetAppCostGroupGet404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.put(`${baseURL}/api/cost-groups/:id`, () => {
    const resultArray = [
      [getPutAppCostGroupUpdate200Response(), { status: 200 }],
      [getPutAppCostGroupUpdate400Response(), { status: 400 }],
      [getPutAppCostGroupUpdate404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.delete(`${baseURL}/api/cost-groups/:id`, () => {
    const resultArray = [
      [null, { status: 204 }],
      [getDeleteAppCostGroupDelete404Response(), { status: 404 }],
      [getDeleteAppCostGroupDelete409Response(), { status: 409 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/payment-methods`, () => {
    const resultArray = [
      [getGetAppPaymentMethodListMine200Response(), { status: 200 }],
      [getGetAppPaymentMethodListMine400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/private-customers/exact`, () => {
    const resultArray = [
      [getGetAppPrivateCustomerGetExact200Response(), { status: 200 }],
      [getGetAppPrivateCustomerGetExact400Response(), { status: 400 }],
      [getGetAppPrivateCustomerGetExact404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/related-customers/mine`, () => {
    const resultArray = [
      [getPostAppRelatedCustomerCreateMine201Response(), { status: 201 }],
      [getPostAppRelatedCustomerCreateMine400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/related-customers/:id`, () => {
    const resultArray = [
      [getGetAppRelatedCustomerGet200Response(), { status: 200 }],
      [getGetAppRelatedCustomerGet404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.put(`${baseURL}/api/related-customers/:id`, () => {
    const resultArray = [
      [getPutAppRelatedCustomerUpdate200Response(), { status: 200 }],
      [getPutAppRelatedCustomerUpdate400Response(), { status: 400 }],
      [getPutAppRelatedCustomerUpdate404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/api/related-customers`, () => {
    const resultArray = [
      [getGetAppRelatedCustomerList200Response(), { status: 200 }],
      [getGetAppRelatedCustomerList400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/related-customers/:id/remove`, () => {
    const resultArray = [
      [getPostAppRelatedCustomerRemove200Response(), { status: 200 }],
      [getPostAppRelatedCustomerRemove404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/stripe/confirm-method`, () => {
    const resultArray = [
      [getPostAppStripeConfirmMethod200Response(), { status: 200 }],
      [getPostAppStripeConfirmMethod400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/stripe/reconfirm/:id`, () => {
    const resultArray = [
      [getPostAppStripeReconfirm200Response(), { status: 200 }],
      [getPostAppStripeReconfirm404Response(), { status: 404 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
];

export function getGetAppBusinessCustomerGetCurrent200Response() {
  return {
    id: 'comes',
    companyName: 'Irene Muller',
    registrationNumber: 'tutamen',
    address: 'celo',
    vatNumber: 'admoneo',
    email: 'Donavon_Gleason@yahoo.com',
    emailMarketing: false,
    contractNumber: 'argentum',
    verified: true,
    representative: {
      areaCode: 'cedo',
      phoneNumber: 'necessitatibus',
      name: 'Derrick Schoen',
    },
    wallet: { balance: 'corrigo' },
    created: '2024-01-15T23:24:14.959Z',
  };
}

export function getGetAppBusinessCustomerGetCurrent404Response() {
  return { code: 5785502389108736, message: 'commodo' };
}

export function getGetAppAuthorizedPersonList200Response() {
  return {
    pagination: {
      pageLimit: 6175894014001152,
      currentPage: 1337393208623104,
      totalItems: 6442198847455232,
      totalPages: 8807235798958080,
    },
    items: [
      {
        // id: 'terror',
        // name: 'Percy Hagenes',
        areaCode: 'aspicio',
        phoneNumber: 'adfectus',
        // email: 'Jovany80@hotmail.com',
      },
      {
        id: 'adipisci',
        name: 'Dianna Hegmann',
        areaCode: 'super',
        phoneNumber: 'adeo',
        email: 'Ewell.Predovic@yahoo.com',
      },
      {
        id: 'volva',
        name: 'Mr. Terrell Douglas',
        areaCode: 'pel',
        phoneNumber: 'velit',
        email: 'Aiyana16@gmail.com',
      },
      {
        id: 'cognatus',
        name: 'Laurie Strosin II',
        areaCode: 'bellicus',
        phoneNumber: 'creta',
        email: 'Raymond_McClure@yahoo.com',
      },
      {
        id: 'umerus',
        name: 'Jorge Shields',
        areaCode: 'adicio',
        phoneNumber: 'terror',
        email: 'Cassidy_Wyman-Johns@yahoo.com',
      },
    ],
  };
}

export function getGetAppAuthorizedPersonList400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAppAuthorizedPersonCreate200Response() {
  return {
    id: 'demoror',
    name: 'Mrs. Melissa Daugherty',
    areaCode: 'demum',
    phoneNumber: 'solum',
    email: 'Hattie69@hotmail.com',
  };
}

export function getPostAppAuthorizedPersonCreate400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getDeleteAppAuthorizedPersonDelete404Response() {
  return { code: 5672279178477568, message: 'accusantium' };
}

export function getPostAppBusinessCustomerCreate201Response() {
  return {
    id: 'tergeo',
    companyName: 'Judy Bayer',
    registrationNumber: 'inflammatio',
    address: 'dignissimos',
    vatNumber: 'magni',
    email: 'Mohammad_Gulgowski6@yahoo.com',
    emailMarketing: true,
    contractNumber: 'angelus',
    verified: true,
    representative: {
      areaCode: 'desparatus',
      phoneNumber: 'cruciamentum',
      name: 'Miss Olivia Waters II',
    },
    wallet: { balance: 'contego' },
    created: '2024-01-04T07:50:15.069Z',
  };
}

export function getPostAppBusinessCustomerCreate400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAppBusinessCustomerCreate409Response() {
  return { code: 2560868627775488, message: 'usitas', type: 'usque' };
}

export function getPostAppCostGroupCreate201Response() {
  return {
    id: 'alter',
    name: 'Julian Stiedemann',
    paymentMethod: { id: 'advenio' },
    dailyAmount: 'teres',
    created: '2023-06-07T19:47:35.991Z',
    updated: '2023-12-23T20:47:54.831Z',
  };
}

export function getPostAppCostGroupCreate400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      { field: 'input', errors: ['Input is invalid!', 'Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getGetAppCostGroupGet200Response() {
  return {
    id: 'patior',
    name: 'Ruth Maggio IV',
    paymentMethod: { id: 'accusator' },
    dailyAmount: 'aegrotatio',
    created: '2023-09-17T02:55:48.443Z',
    updated: '2023-10-04T06:34:22.136Z',
  };
}

export function getGetAppCostGroupGet404Response() {
  return { code: 5287276519096320, message: 'uterque' };
}

export function getPutAppCostGroupUpdate200Response() {
  return {
    id: 'rem',
    name: 'Katrina Torp',
    paymentMethod: { id: 'coerceo' },
    dailyAmount: 'summisse',
    created: '2023-10-21T23:41:55.109Z',
    updated: '2023-10-12T04:47:57.252Z',
  };
}

export function getPutAppCostGroupUpdate400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPutAppCostGroupUpdate404Response() {
  return { code: 4677323032887296, message: 'crux' };
}

export function getDeleteAppCostGroupDelete404Response() {
  return { code: 8649858952986624, message: 'dolor' };
}

export function getDeleteAppCostGroupDelete409Response() {
  return { code: 1503425885896704, message: 'amplitudo', type: 'socius' };
}

export function getGetAppCostGroupListMine200Response() {
  return {
    pagination: {
      pageLimit: 5680478191353856,
      currentPage: 2210690601320448,
      totalItems: 5257503394758656,
      totalPages: 7082439864221696,
    },
    items: [
      {
        id: 'usque',
        name: 'Norman Purdy',
        paymentMethod: { id: 'vir' },
        dailyAmount: 'doloremque',
      },
      {
        id: 'tum',
        name: 'Jane Ondricka Jr.',
        paymentMethod: { id: 'causa' },
        dailyAmount: 'ducimus',
      },
      {
        id: 'quis',
        name: 'Josephine Keebler',
        paymentMethod: { id: 'vulnus' },
        dailyAmount: 'corrumpo',
      },
      {
        id: 'audax',
        name: 'Marvin Brakus',
        paymentMethod: { id: 'vel' },
        dailyAmount: 'cilicium',
      },
      {
        id: 'absorbeo',
        name: 'Emma Koch',
        paymentMethod: { id: 'utrum' },
        dailyAmount: 'canto',
      },
      {
        id: 'tertius',
        name: 'Brittany Jenkins',
        paymentMethod: { id: 'crepusculum' },
        dailyAmount: 'vespillo',
      },
      {
        id: 'umquam',
        name: 'Alicia Nikolaus',
        paymentMethod: { id: 'curtus' },
        dailyAmount: 'sopor',
      },
      {
        id: 'cras',
        name: 'Van Parisian',
        paymentMethod: { id: 'dolorem' },
        dailyAmount: 'perspiciatis',
      },
      {
        id: 'denuncio',
        name: 'Lana Schaefer',
        paymentMethod: { id: 'quidem' },
        dailyAmount: 'aduro',
      },
      {
        id: 'solus',
        name: 'Jared Walker',
        paymentMethod: { id: 'careo' },
        dailyAmount: 'creator',
      },
      {
        id: 'agnosco',
        name: 'Randall Hansen',
        paymentMethod: { id: 'cohaero' },
        dailyAmount: 'similique',
      },
      {
        id: 'statim',
        name: 'Samuel Herman',
        paymentMethod: { id: 'demulceo' },
        dailyAmount: 'vado',
      },
      {
        id: 'contego',
        name: 'Mrs. Colleen Zemlak',
        paymentMethod: { id: 'uredo' },
        dailyAmount: 'valde',
      },
    ],
  };
}

export function getGetAppCostGroupListMine400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getGetAppPaymentMethodListMine200Response() {
  return [
    {
      id: 'vitiosus',
      type: 'stripe',
      title: 'sufficio',
      default: false,
      brand: 'et',
      details: { methodId: 'subvenio' },
    },
    {
      id: 'tondeo',
      type: 'stripe',
      title: 'inventore',
      default: true,
      brand: 'confido',
      details: { methodId: 'magni' },
    },
    {
      id: 'quod',
      type: 'stripe',
      title: 'minima',
      default: true,
      brand: 'denuncio',
      details: { methodId: 'tego' },
    },
    {
      id: 'voluptatibus',
      type: 'stripe',
      title: 'conduco',
      default: false,
      brand: 'suppellex',
      details: { methodId: 'aegre' },
    },
    {
      id: 'vicissitudo',
      type: 'stripe',
      title: 'veritas',
      default: false,
      brand: 'cavus',
      details: { methodId: 'decor' },
    },
    {
      id: 'quod',
      type: 'stripe',
      title: 'conspergo',
      default: false,
      brand: 'aranea',
      details: { methodId: 'articulus' },
    },
    {
      id: 'vestrum',
      type: 'stripe',
      title: 'subiungo',
      default: false,
      brand: 'conspergo',
      details: { methodId: 'theologus' },
    },
    {
      id: 'thesis',
      type: 'stripe',
      title: 'aureus',
      default: true,
      brand: 'sustineo',
      details: { methodId: 'suus' },
    },
    {
      id: 'eum',
      type: 'stripe',
      title: 'casso',
      default: false,
      brand: 'ars',
      details: { methodId: 'undique' },
    },
    {
      id: 'libero',
      type: 'stripe',
      title: 'curso',
      default: true,
      brand: 'vergo',
      details: { methodId: 'canonicus' },
    },
    {
      id: 'angulus',
      type: 'stripe',
      title: 'baiulus',
      default: true,
      brand: 'temptatio',
      details: { methodId: 'teneo' },
    },
    {
      id: 'excepturi',
      type: 'stripe',
      title: 'apparatus',
      default: true,
      brand: 'coepi',
      details: { methodId: 'volo' },
    },
    {
      id: 'venio',
      type: 'stripe',
      title: 'deludo',
      default: true,
      brand: 'atque',
      details: { methodId: 'cumque' },
    },
    {
      id: 'tot',
      type: 'stripe',
      title: 'curso',
      default: true,
      brand: 'coma',
      details: { methodId: 'est' },
    },
    {
      id: 'dicta',
      type: 'stripe',
      title: 'sortitus',
      default: true,
      brand: 'sed',
      details: { methodId: 'creptio' },
    },
    {
      id: 'tandem',
      type: 'stripe',
      title: 'nisi',
      default: true,
      brand: 'textilis',
      details: { methodId: 'talis' },
    },
    {
      id: 'omnis',
      type: 'stripe',
      title: 'super',
      default: true,
      brand: 'crur',
      details: { methodId: 'ago' },
    },
    {
      id: 'deprecator',
      type: 'stripe',
      title: 'via',
      default: false,
      brand: 'curto',
      details: { methodId: 'amor' },
    },
    {
      id: 'statim',
      type: 'stripe',
      title: 'comprehendo',
      default: true,
      brand: 'molestiae',
      details: { methodId: 'speculum' },
    },
    {
      id: 'sulum',
      type: 'stripe',
      title: 'colo',
      default: false,
      brand: 'victus',
      details: { methodId: 'textus' },
    },
  ];
}

export function getGetAppPaymentMethodListMine400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!', 'Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getGetAppPrivateCustomerGetExact200Response() {
  return {
    id: 'varietas',
    name: 'Lyle Satterfield',
    areaCode: 'veniam',
    phoneNumber: 'assentator',
    email: 'Tania98@yahoo.com',
  };
}

export function getGetAppPrivateCustomerGetExact400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getGetAppPrivateCustomerGetExact404Response() {
  return { code: 3221094517440512, message: 'paulatim' };
}

export function getPostAppRelatedCustomerCreateMine201Response() {
  return {
    id: 'corrupti',
    privateCustomer: {
      id: 'debitis',
      name: 'Patrick Weber',
      email: 'Shayna.Rodriguez51@hotmail.com',
      areaCode: 'crur',
      phoneNumber: 'capio',
    },
    businessCustomer: {
      id: 'vito',
      companyName: 'Dr. Evan Armstrong',
      registrationNumber: 'sursum',
    },
    totalReservations: 1299722107092992,
    costGroup: { id: 'quae', name: 'Brad Graham', dailyAmount: 'comis' },
    compensationType: 'duration',
    limitDays: 1263225094012928,
    limitMaxAmount: 'civis',
    limitFromDateTime: '2023-08-24T04:33:36.304Z',
    limitToDateTime: '2023-10-04T07:24:02.346Z',
    invoicingComment: 'culpa',
    deleted: '2024-01-07T04:01:28.759Z',
    created: '2024-01-21T11:13:17.972Z',
    updated: '2023-06-07T09:50:07.263Z',
  };
}

export function getPostAppRelatedCustomerCreateMine400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!', 'Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getGetAppRelatedCustomerGet200Response() {
  return {
    id: 'capillus',
    privateCustomer: {
      id: 'certe',
      name: 'Lola Ziemann',
      email: 'Syble17@gmail.com',
      areaCode: 'defessus',
      phoneNumber: 'utpote',
    },
    businessCustomer: {
      id: 'vilicus',
      companyName: 'Greg Hahn-Johnson',
      registrationNumber: 'tempore',
    },
    totalReservations: 2094671492808704,
    costGroup: { id: 'supra', name: 'Laura Powlowski', dailyAmount: 'ustilo' },
    compensationType: 'duration_distance',
    limitDays: 5111413322285056,
    limitMaxAmount: 'sperno',
    limitFromDateTime: '2023-03-14T03:41:36.807Z',
    limitToDateTime: '2023-03-23T22:18:27.669Z',
    invoicingComment: 'cultura',
    deleted: '2023-05-30T22:04:11.799Z',
    created: '2023-07-16T20:49:48.097Z',
    updated: '2023-10-08T21:33:04.876Z',
  };
}

export function getGetAppRelatedCustomerGet404Response() {
  return { code: 1643721839869952, message: 'arca' };
}

export function getPutAppRelatedCustomerUpdate200Response() {
  return {
    id: 'pecco',
    privateCustomer: {
      id: 'commodo',
      name: 'Bernard Braun',
      email: 'Stanford.Cummings53@gmail.com',
      areaCode: 'tenus',
      phoneNumber: 'terga',
    },
    businessCustomer: {
      id: 'statim',
      companyName: 'Dixie Herman',
      registrationNumber: 'sordeo',
    },
    totalReservations: 3542263258939392,
    costGroup: {
      id: 'peccatus',
      name: 'Candace Bailey',
      dailyAmount: 'desidero',
    },
    compensationType: 'duration_distance',
    limitDays: 8239771027505152,
    limitMaxAmount: 'dedico',
    limitFromDateTime: '2023-07-10T11:30:27.909Z',
    limitToDateTime: '2023-10-23T17:22:43.002Z',
    invoicingComment: 'audax',
    deleted: '2023-06-23T01:53:52.905Z',
    created: '2023-09-20T02:01:30.497Z',
    updated: '2023-06-12T13:34:54.198Z',
  };
}

export function getPutAppRelatedCustomerUpdate400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!', 'Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPutAppRelatedCustomerUpdate404Response() {
  return { code: 3745305807814656, message: 'ea' };
}

export function getGetAppRelatedCustomerList200Response() {
  return {
    pagination: {
      pageLimit: 5275284781662208,
      currentPage: 3206590668734464,
      totalItems: 4224900673830912,
      totalPages: 7215645756227584,
    },
    items: [
      {
        id: 'delego',
        privateCustomer: {
          // id: 'asper',
          // name: 'Henrietta Bechtelar',
          // email: 'Ericka.Moen-Breitenberg98@gmail.com',
          areaCode: 'pecus',
          phoneNumber: 'a',
        },
        totalReservations: 782918119063552,
        costGroup: { id: 'appono', name: 'Fred Orn', dailyAmount: 'timor' },
        compensationType: 'duration',
        limitDays: 45186352676864,
        limitFromDateTime: '2023-08-26T16:58:46.907Z',
        limitToDateTime: '2024-02-21T18:50:58.952Z',
        invoicingComment: 'annus',
        deleted: '2023-11-01T01:54:27.085Z',
        created: '2023-07-06T00:05:03.011Z',
        updated: '2023-12-08T12:00:16.428Z',
      },
      {
        id: 'caecus',
        privateCustomer: {
          id: 'caste',
          name: 'Dr. Hugh Nicolas',
          email: 'Trey70@gmail.com',
          areaCode: 'caecus',
          phoneNumber: 'vehemens',
        },
        totalReservations: 1455641233195008,
        costGroup: {
          id: 'uter',
          name: 'Mr. Ramiro Rohan',
          dailyAmount: 'quos',
        },
        compensationType: 'distance',
        limitDays: 390531842572288,
        limitFromDateTime: '2023-08-16T14:27:21.010Z',
        limitToDateTime: '2023-12-21T13:54:58.115Z',
        invoicingComment: 'qui',
        deleted: '2023-11-05T08:05:09.142Z',
        created: '2023-12-17T18:34:34.970Z',
        updated: '2023-07-29T22:58:58.055Z',
      },
      {
        id: 'spiritus',
        privateCustomer: {
          id: 'sumo',
          name: 'Tonya Barrows I',
          email: 'Neoma.Rippin@yahoo.com',
          areaCode: 'cuius',
          phoneNumber: 'viriliter',
        },
        totalReservations: 4412504023236608,
        costGroup: {
          id: 'acervus',
          name: 'Charles Block',
          dailyAmount: 'impedit',
        },
        compensationType: 'duration_distance',
        limitDays: 7904521156034560,
        limitFromDateTime: '2023-10-30T21:55:51.117Z',
        limitToDateTime: '2023-03-08T22:39:28.532Z',
        invoicingComment: 'desipio',
        deleted: '2023-03-18T19:10:39.403Z',
        created: '2023-10-29T21:21:04.983Z',
        updated: '2023-04-18T20:30:29.931Z',
      },
      {
        id: 'aestas',
        privateCustomer: {
          id: 'cado',
          name: 'Max Schultz',
          email: 'Kamron_Bechtelar67@yahoo.com',
          areaCode: 'candidus',
          phoneNumber: 'civitas',
        },
        totalReservations: 2015691819450368,
        costGroup: { id: 'summa', name: 'Rudolph Welch', dailyAmount: 'canto' },
        compensationType: 'distance',
        limitDays: 7511422669946880,
        limitFromDateTime: '2023-12-22T01:18:20.623Z',
        limitToDateTime: '2023-10-20T01:07:42.202Z',
        invoicingComment: 'vulariter',
        deleted: '2023-08-10T02:08:55.203Z',
        created: '2023-03-28T03:47:45.023Z',
        updated: '2023-03-03T01:46:16.528Z',
      },
      {
        id: 'valens',
        privateCustomer: {
          id: 'bos',
          name: 'Santiago Johns',
          email: 'Agnes_Renner62@yahoo.com',
          areaCode: 'chirographum',
          phoneNumber: 'chirographum',
        },
        totalReservations: 8150482409226240,
        costGroup: {
          id: 'tertius',
          name: 'Peggy Gorczany',
          dailyAmount: 'apostolus',
        },
        compensationType: 'duration',
        limitDays: 3633418099228672,
        limitFromDateTime: '2023-04-15T18:25:02.816Z',
        limitToDateTime: '2023-06-16T02:24:34.633Z',
        invoicingComment: 'victus',
        deleted: '2023-08-18T14:07:17.690Z',
        created: '2024-01-03T06:50:21.909Z',
        updated: '2023-05-31T09:22:25.377Z',
      },
      {
        id: 'pecus',
        privateCustomer: {
          id: 'appello',
          name: 'Miss Kristy Barton',
          email: 'Bianka_Schroeder@hotmail.com',
          areaCode: 'commodo',
          phoneNumber: 'crustulum',
        },
        totalReservations: 2937882134183936,
        costGroup: {
          id: 'vociferor',
          name: 'Dr. Frederick Crist',
          dailyAmount: 'peccatus',
        },
        compensationType: 'duration_distance',
        limitDays: 2101249914699776,
        limitFromDateTime: '2023-10-20T08:05:23.196Z',
        limitToDateTime: '2024-01-26T14:21:37.541Z',
        invoicingComment: 'numquam',
        deleted: '2023-05-06T01:36:14.683Z',
        created: '2023-05-04T12:35:27.861Z',
        updated: '2023-10-06T20:53:54.081Z',
      },
      {
        id: 'cunabula',
        privateCustomer: {
          id: 'magni',
          name: 'Darryl Considine',
          email: 'Tobin_Fay@yahoo.com',
          areaCode: 'solio',
          phoneNumber: 'tonsor',
        },
        totalReservations: 8124670331060224,
        costGroup: {
          id: 'comes',
          name: 'Shelly Mitchell',
          dailyAmount: 'debilito',
        },
        compensationType: 'duration_distance',
        limitDays: 7498458225180672,
        limitFromDateTime: '2023-04-07T18:02:18.552Z',
        limitToDateTime: '2023-03-07T02:42:25.566Z',
        invoicingComment: 'vos',
        deleted: '2023-10-16T14:55:10.803Z',
        created: '2024-01-06T23:27:15.448Z',
        updated: '2023-12-05T22:55:20.166Z',
      },
      {
        id: 'assentator',
        privateCustomer: {
          id: 'tepidus',
          name: 'Shannon Pouros',
          email: 'Marcel.Larson@hotmail.com',
          areaCode: 'uxor',
          phoneNumber: 'ventosus',
        },
        totalReservations: 2766205645488128,
        costGroup: {
          id: 'adeo',
          name: 'Ms. Sheri Smith',
          dailyAmount: 'totam',
        },
        compensationType: 'duration_distance',
        limitDays: 4142986740891648,
        limitFromDateTime: '2024-01-01T20:45:13.742Z',
        limitToDateTime: '2023-12-06T10:14:53.902Z',
        invoicingComment: 'terror',
        deleted: '2023-12-23T15:05:16.158Z',
        created: '2023-09-27T08:48:58.070Z',
        updated: '2023-07-23T23:00:05.646Z',
      },
      {
        id: 'cur',
        privateCustomer: {
          id: 'ullus',
          name: 'Abraham Ryan DDS',
          email: 'Leopold.Corwin9@gmail.com',
          areaCode: 'arbor',
          phoneNumber: 'triumphus',
        },
        totalReservations: 4931025165615104,
        costGroup: {
          id: 'solio',
          name: 'Jody Aufderhar',
          dailyAmount: 'conscendo',
        },
        compensationType: 'duration_distance',
        limitDays: 3877081045794816,
        limitFromDateTime: '2023-05-17T06:25:41.057Z',
        limitToDateTime: '2023-08-31T04:26:06.747Z',
        invoicingComment: 'vorax',
        deleted: '2024-01-30T15:49:13.841Z',
        created: '2023-03-01T09:09:17.592Z',
        updated: '2023-06-08T07:14:10.311Z',
      },
      {
        id: 'tardus',
        privateCustomer: {
          id: 'arx',
          name: 'Janis Bins',
          email: 'Jonatan_Rolfson77@gmail.com',
          areaCode: 'timidus',
          phoneNumber: 'acer',
        },
        totalReservations: 6258487310942208,
        costGroup: {
          id: 'terreo',
          name: 'Milton Turcotte',
          dailyAmount: 'demonstro',
        },
        compensationType: 'duration_distance',
        limitDays: 2660478025203712,
        limitFromDateTime: '2023-03-22T22:32:05.931Z',
        limitToDateTime: '2023-03-28T09:37:37.556Z',
        invoicingComment: 'rem',
        deleted: '2023-10-11T03:39:33.425Z',
        created: '2023-11-04T04:00:34.505Z',
        updated: '2023-11-18T07:41:16.187Z',
      },
      {
        id: 'conspergo',
        privateCustomer: {
          id: 'conor',
          name: 'Justin Pagac',
          email: 'Bill_Durgan@yahoo.com',
          areaCode: 'thymbra',
          phoneNumber: 'cohibeo',
        },
        totalReservations: 8928926101405696,
        costGroup: {
          id: 'tempora',
          name: 'Dr. Marlon Collier V',
          dailyAmount: 'cui',
        },
        compensationType: 'distance',
        limitDays: 6168544987316224,
        limitFromDateTime: '2023-02-27T15:36:18.632Z',
        limitToDateTime: '2023-11-17T20:58:23.101Z',
        invoicingComment: 'solutio',
        deleted: '2023-10-07T10:01:15.705Z',
        created: '2023-04-01T07:01:13.243Z',
        updated: '2023-08-21T23:34:15.459Z',
      },
      {
        id: 'in',
        privateCustomer: {
          id: 'sodalitas',
          name: 'Calvin Lubowitz-Pacocha',
          email: 'Joanne_Gleichner@gmail.com',
          areaCode: 'vergo',
          phoneNumber: 'tondeo',
        },
        totalReservations: 4378496476381184,
        costGroup: { id: 'pariatur', name: 'Pam Rolfson', dailyAmount: 'nam' },
        compensationType: 'duration_distance',
        limitDays: 7609799145422848,
        limitFromDateTime: '2023-08-08T11:12:44.007Z',
        limitToDateTime: '2023-11-13T21:28:31.205Z',
        invoicingComment: 'tui',
        deleted: '2024-01-14T07:20:25.777Z',
        created: '2023-06-01T07:50:32.761Z',
        updated: '2023-11-28T21:33:41.839Z',
      },
      {
        id: 'tabernus',
        privateCustomer: {
          id: 'dolore',
          name: 'Julie Padberg',
          email: 'Bernard_Moore31@hotmail.com',
          areaCode: 'acceptus',
          phoneNumber: 'absque',
        },
        totalReservations: 6193678206894080,
        costGroup: {
          id: 'deporto',
          name: 'Elijah Stoltenberg',
          dailyAmount: 'curvo',
        },
        compensationType: 'duration_distance',
        limitDays: 8197284009345024,
        limitFromDateTime: '2023-04-26T02:42:31.866Z',
        limitToDateTime: '2023-06-20T17:48:54.827Z',
        invoicingComment: 'confido',
        deleted: '2023-09-12T23:10:23.447Z',
        created: '2023-04-17T06:47:05.561Z',
        updated: '2023-09-10T11:29:30.729Z',
      },
      {
        id: 'deserunt',
        privateCustomer: {
          id: 'attonbitus',
          name: 'Mandy Hyatt-Harber',
          email: 'America.Sipes@hotmail.com',
          areaCode: 'xiphias',
          phoneNumber: 'vito',
        },
        totalReservations: 6344800475283456,
        costGroup: {
          id: 'saepe',
          name: 'Karen Turner',
          dailyAmount: 'volubilis',
        },
        compensationType: 'duration_distance',
        limitDays: 1562589895065600,
        limitFromDateTime: '2023-05-01T19:21:30.088Z',
        limitToDateTime: '2023-10-15T01:24:41.474Z',
        invoicingComment: 'terror',
        deleted: '2023-12-23T11:57:10.480Z',
        created: '2023-04-10T07:18:01.451Z',
        updated: '2023-09-18T18:42:21.725Z',
      },
      {
        id: 'libero',
        privateCustomer: {
          id: 'concedo',
          name: 'Samantha Mosciski',
          email: 'Chandler.Grimes@yahoo.com',
          areaCode: 'benevolentia',
          phoneNumber: 'antepono',
        },
        totalReservations: 799275686559744,
        costGroup: {
          id: 'antiquus',
          name: 'Denise Balistreri',
          dailyAmount: 'territo',
        },
        compensationType: 'duration',
        limitDays: 5877218349678592,
        limitFromDateTime: '2023-03-13T17:02:46.370Z',
        limitToDateTime: '2024-01-12T18:33:14.514Z',
        invoicingComment: 'aegrotatio',
        deleted: '2023-05-13T16:40:29.875Z',
        created: '2024-01-25T10:57:22.074Z',
        updated: '2023-11-21T20:01:06.199Z',
      },
      {
        id: 'conor',
        privateCustomer: {
          id: 'adimpleo',
          name: 'Rachel Crona',
          email: 'Abe_Shanahan@yahoo.com',
          areaCode: 'conicio',
          phoneNumber: 'rerum',
        },
        totalReservations: 3357396833402880,
        costGroup: {
          id: 'recusandae',
          name: 'Dr. Nicolas Thiel',
          dailyAmount: 'defluo',
        },
        compensationType: 'duration',
        limitDays: 4670368878952448,
        limitFromDateTime: '2023-12-30T07:44:37.993Z',
        limitToDateTime: '2023-06-24T20:02:29.222Z',
        invoicingComment: 'demergo',
        deleted: '2024-01-29T03:41:43.780Z',
        created: '2023-03-06T19:18:00.813Z',
        updated: '2023-10-08T05:21:32.830Z',
      },
      {
        id: 'socius',
        privateCustomer: {
          id: 'suffragium',
          name: 'Belinda Schuster',
          email: 'Ken72@yahoo.com',
          areaCode: 'campana',
          phoneNumber: 'coniuratio',
        },
        totalReservations: 5816479842828288,
        costGroup: {
          id: 'trepide',
          name: 'Nicholas Yundt',
          dailyAmount: 'advenio',
        },
        compensationType: 'duration',
        limitDays: 4982183928266752,
        limitFromDateTime: '2023-10-23T13:09:54.373Z',
        limitToDateTime: '2023-06-09T07:02:58.145Z',
        invoicingComment: 'debitis',
        deleted: '2023-09-13T00:29:46.131Z',
        created: '2023-10-06T02:06:00.998Z',
        updated: '2023-07-15T23:48:39.216Z',
      },
      {
        id: 'vulnus',
        privateCustomer: {
          id: 'virga',
          name: 'Tim Windler',
          email: 'Mozell.Lind@gmail.com',
          areaCode: 'fugiat',
          phoneNumber: 'accommodo',
        },
        totalReservations: 5471670689071104,
        costGroup: {
          id: 'abbas',
          name: 'Juanita Lesch Sr.',
          dailyAmount: 'calamitas',
        },
        compensationType: 'duration_distance',
        limitDays: 1087849441001472,
        limitFromDateTime: '2023-07-30T13:01:43.011Z',
        limitToDateTime: '2023-09-16T11:56:55.941Z',
        invoicingComment: 'ager',
        deleted: '2023-07-06T13:44:28.559Z',
        created: '2024-02-09T19:53:04.170Z',
        updated: '2023-09-01T14:53:47.463Z',
      },
    ],
  };
}

export function getGetAppRelatedCustomerList400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAppRelatedCustomerRemove200Response() {
  return { deleted: true };
}

export function getPostAppRelatedCustomerRemove404Response() {
  return { code: 2036334598291456, message: 'aggero' };
}

export function getPostAppStripeConfirmMethod200Response() {
  return {
    details: {
      clientSecret: 'aestas',
      error: 'INSUFFICIENT_FUNDS',
      paymentMethodId: 'vos',
      type: 'stripe',
    },
    id: 'abundans',
    status: 'paid',
  };
}

export function getPostAppStripeConfirmMethod400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAppStripeReconfirm200Response() {
  return {
    details: {
      clientSecret: 'antiquus',
      error: 'REQUIRES_AUTHENTICATION',
      paymentMethodId: 'concedo',
      type: 'stripe',
    },
    id: 'virtus',
    status: 'unpaid',
  };
}

export function getPostAppStripeReconfirm404Response() {
  return { code: 8557891441131520, message: 'bene' };
}

// This configures a Service Worker with the given request handlers.
export const startWorker = () => {
  const worker = setupWorker(...handlers);
  worker.start();
};
